class CustomerReviewsSlider extends HTMLElement {
  constructor() {
    super()
    this.currentIndex = 0
  }

  connectedCallback() {
    this.slider = this.querySelector(".customer-reviews__slider")
    this.wrapper = this.querySelector(".customer-reviews__slider-wrapper")
    this.cards = this.querySelectorAll(".customer-reviews__card")

    this.prevButton = this.querySelector(".customer-reviews__nav-button--prev")
    this.nextButton = this.querySelector(".customer-reviews__nav-button--next")
    this.progressBar = this.querySelector(".customer-reviews__progress-bar")

    if (!this.slider || !this.wrapper) return

    this.bindEvents()
    this.update()
  }

  isMobile() {
    return window.innerWidth <= 768
  }

  getItemsPerView() {
    if (this.isMobile()) return 1
    if (window.innerWidth <= 1024) return 2
    return 3
  }

  getMaxIndex() {
    return Math.max(0, this.cards.length - this.getItemsPerView())
  }

  /* --------------------
     UPDATE POSITION
  -------------------- */
  update() {
    const maxIndex = this.getMaxIndex()
    this.currentIndex = Math.max(0, Math.min(this.currentIndex, maxIndex))

    if (this.isMobile()) {
      const cardWidth = this.cards[0].offsetWidth
      this.wrapper.scrollTo({
        left: this.currentIndex * cardWidth,
        behavior: "smooth"
      })
    } else {
      const cardWidth = this.cards[0].offsetWidth
      const gap = 24
      this.slider.style.transform =
        `translateX(-${this.currentIndex * (cardWidth + gap)}px)`
    }

    this.updateUI()
  }

  updateUI() {
    const maxIndex = this.getMaxIndex()

    if (this.prevButton)
      this.prevButton.disabled = this.currentIndex === 0

    if (this.nextButton)
      this.nextButton.disabled = this.currentIndex >= maxIndex

    if (this.progressBar) {
      if (maxIndex > 0) {
        this.progressBar.style.width =
          `${((this.currentIndex + 1) / (maxIndex + 1)) * 100}%`
      } else {
        this.progressBar.style.width = "100%"
      }
    }
  }

  /* --------------------
     EVENTS
  -------------------- */
  bindEvents() {
    this.prevButton?.addEventListener("click", () => {
      this.currentIndex--
      this.update()
    })

    this.nextButton?.addEventListener("click", () => {
      this.currentIndex++
      this.update()
    })

    /* MOBILE: native scroll → index sync */
    this.wrapper.addEventListener("scroll", () => {
      if (!this.isMobile()) return

      const cardWidth = this.cards[0].offsetWidth
      const newIndex = Math.round(this.wrapper.scrollLeft / cardWidth)

      if (newIndex !== this.currentIndex) {
        this.currentIndex = newIndex
        this.updateUI()
      }
    })

    window.addEventListener("resize", () => this.update())
  }
}

if (!customElements.get("customer-reviews-slider")) {
  customElements.define("customer-reviews-slider", CustomerReviewsSlider)
}

